import Offcanvas from "react-bootstrap/Offcanvas";
import Dropdown from "react-bootstrap/Dropdown";
import React, { useEffect, useState } from "react";
import {
  PlusLg,
  Ticket,
  QrCodeScan,
  WindowSidebar,
  Person,
  Box,
  QuestionCircle,
  BoxArrowLeft,
  Globe,
  ListStars,
  Speedometer2,
  Archive,
  Calendar4,
  Globe2,
  Gear,
} from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useGetOrganizerServiceInfoQuery } from "../../qraphql/event.hooks";
import classNames from "classnames";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import MediaIcon from "./icons/MediaIcon";
import { WhiteLabelPaths } from "../../App";
import { useReactiveVar } from "@apollo/client";
import {
  whiteLabelJRStartModal,
  whiteLabelStep,
} from "../../qraphql/globalVar/state";
import { WhiteLaelStepEnum } from "../../types";
import WhiteLabelLink from "./WhiteLabelLink";
import { useOrganizerWhiteLabelQuery } from "../../qraphql/whiteLabel/whiteLabel.hooks";

export const languages = [
  { value: "en", label: "English" },
  { value: "vi", label: "Tiếng Việt" },
  { value: "de", label: "Deutsch" },
  { value: "ar", label: "عرب" },
  { value: "th", label: "ไทย" },
  { value: "ko", label: "한국인" },
  { value: "ja", label: "日本" },
  { value: "it", label: "Italiano" },
  { value: "hi", label: "हिंदी" },
  { value: "ms", label: "Bahasa Melayu" },
  { value: "id", label: "Bahasa Indonesia" },
  { value: "es", label: "Español" },
  { value: "fr", label: "Français" },
  { value: "pt", label: "Português" },
  { value: "nl", label: "Nederlands" },
  { value: "sv", label: "Svenska" },
  { value: "pl", label: "Polski" },
  { value: "uk", label: "Українська" },
];

const ME_TICKET_LINK = process.env.REACT_APP_TICKET_URL;

export default function Menu() {
  const navigate = useNavigate();
  const lng = useGetUrlLocale();
  const [searchParams] = useSearchParams();
  const { data, loading } = useGetOrganizerServiceInfoQuery();
  const { data: whiteLabelData, loading: whiteLabelLoading } =
    useOrganizerWhiteLabelQuery({
      fetchPolicy: "network-only",
      onCompleted(data) {
        if (data.organizer?.whiteLabel?.domain) {
          whiteLabelStep(WhiteLaelStepEnum.MediaDesign);
        } else if (data.organizer?.whiteLabel?.projectName) {
          whiteLabelStep(WhiteLaelStepEnum.CustomDomain);
        }
      },
    });
  const [show, setShow] = useState(false);

  const { t, i18n } = useTranslation();
  const isProOrganizeer = data?.activeSubscription;
  const currentWhiteLabelStep = useReactiveVar(whiteLabelStep);
  const locale =
    i18n.language.split("-")[0] === "en"
      ? ""
      : `/${i18n.language.split("-")[0]}`;

  const lang = i18n.language.split("-")[0];

  const changeLanguage = (lng: string) => {
    const queryParams = new URLSearchParams(location.search).toString();

    const currentPath = location.pathname
      .split("/")
      .slice(i18n.language.split("-")[0] === "en" ? 1 : 2)
      .join("/");

    const newPath = lng === "en" ? `/${currentPath}` : `/${lng}/${currentPath}`;
    const finalPath = queryParams ? `${newPath}?${queryParams}` : newPath;

    navigate(finalPath, { replace: true });
    i18n.changeLanguage(lng);
  };

  if (data?.needVerifyEmail) {
    window.location.href = `${process.env.REACT_APP_TICKET_URL}${locale}/for-organizers/profile`;
  }

  const handleHowToStart = () => {
    if (whiteLabelLoading) return;
    setShow(false);
    navigate(`${lng}/project-settings`);
    whiteLabelJRStartModal(true);
  };

  useEffect(() => {
    if (
      searchParams.get("howtostart") === "1" &&
      !whiteLabelLoading &&
      !whiteLabelData?.organizer?.whiteLabel?.domain
    ) {
      handleHowToStart();
      const path = window.location.pathname;
      navigate(path, { replace: true });
    }
  }, [searchParams, navigate, whiteLabelLoading, whiteLabelData]);

  return (
    <>
      <div className="col-12 col-lg-3 col-xl-2 bg-white border-end">
        <div className="col-12 col-lg-3 col-xl-2 d-none d-lg-flex admin-left-menu p-4 h-100 flex-column justify-content-between fixed-top overflow-y-auto custom-scrollbar">
          <div className="text-dark">
            <div className=" text-center">
              <a
                href={ME_TICKET_LINK + locale + "/for-organizers/"}
                className="pb-4 d-inline-block"
              >
                <img
                  src="https://me-ticket.com/assets/img/logo.svg"
                  alt="Me ticket"
                  width="125"
                  height="40"
                />
              </a>
            </div>
            <small>
              <p className="pt-2">{t("menu.main")}</p>
              <ul className="nav flex-column">
                <li className="nav-item mb-2">
                  <a
                    className="nav-link text-success text-capitalize"
                    aria-current="page"
                    href={locale + "/create-event"}
                  >
                    <PlusLg className="pe-2 fs-4" /> {t("menu.create")}
                  </a>
                </li>
                <li className="nav-item mb-2">
                  <a
                    className="nav-link"
                    href={ME_TICKET_LINK + locale + "/for-organizers/my-events"}
                  >
                    <Ticket className="pe-2 fs-4" /> {t("menu.events")}
                  </a>
                </li>
                <li className="nav-item mb-2">
                  <a
                    className="nav-link "
                    href={
                      ME_TICKET_LINK +
                      locale +
                      "/for-organizers/ticket-scanner-app"
                    }
                  >
                    <QrCodeScan className="pe-2 fs-4" /> {t("menu.ticket")}
                  </a>
                </li>
                <li className="nav-item mb-2 ">
                  <a
                    className={classNames("nav-link", {
                      "opacity-25 disabled": !isProOrganizeer || loading,
                    })}
                    href={ME_TICKET_LINK + locale + "/for-organizers/statistic"}
                  >
                    <WindowSidebar className="pe-2 fs-4" />{" "}
                    {t("menu.statistics")}
                  </a>
                </li>
                <li className="nav-item mb-2">
                  <a
                    className="nav-link "
                    href={ME_TICKET_LINK + locale + "/for-organizers/profile"}
                  >
                    <Person className="pe-2 fs-4" /> {t("menu.profile")}
                  </a>
                </li>
                <li className="nav-item mb-2">
                  <a
                    className="nav-link "
                    href={
                      ME_TICKET_LINK +
                      locale +
                      "/for-organizers/payment-subscription"
                    }
                  >
                    <Calendar4 className="pe-2 fs-4" />{" "}
                    {t("menu.Payment & Subscription")}
                  </a>
                </li>
                <li className="nav-item mb-2">
                  <a
                    className="nav-link "
                    href={
                      ME_TICKET_LINK + locale + "/for-organizers/archive/events"
                    }
                  >
                    <Box className="pe-2 fs-4" /> {t("menu.archive")}
                  </a>
                </li>
                <li className="nav-item mb-3">
                  <a
                    className="nav-link "
                    target="_blank"
                    href={ME_TICKET_LINK + locale + "/organizer-support-chat"}
                    rel="noopener noreferrer"
                  >
                    <QuestionCircle className="pe-2 fs-4" /> {t("menu.support")}
                  </a>
                </li>

                <div className="mb-3 d-flex justify-content-between">
                  <div>{t("menu.White Label")}</div>
                  {currentWhiteLabelStep !== WhiteLaelStepEnum.MediaDesign && (
                    <div
                      className={`text-decoration-underline text-success ${whiteLabelLoading ? "text-opacity-50" : "cursor-pointer"}`}
                      onClick={handleHowToStart}
                    >
                      {t("whiteLabel.How to Start?")}
                    </div>
                  )}
                </div>
                <li className="nav-item mb-2">
                  <WhiteLabelLink
                    to={`${lng}${WhiteLabelPaths.ProjectSettings}`}
                    isActive={location.pathname.includes(
                      WhiteLabelPaths.ProjectSettings
                    )}
                  >
                    <Gear className="pe-2 fs-4" /> {t("menu.Project Settings")}
                  </WhiteLabelLink>
                </li>
                <li className="nav-item mb-2">
                  <WhiteLabelLink
                    to={`${lng}${WhiteLabelPaths.CustomDomain}`}
                    isActive={location.pathname.includes(
                      WhiteLabelPaths.CustomDomain
                    )}
                    disabled={
                      currentWhiteLabelStep < WhiteLaelStepEnum.CustomDomain
                    }
                  >
                    <Globe2 className="pe-2 fs-4" /> {t("menu.Custom Domain")}
                  </WhiteLabelLink>
                </li>
                <li className="nav-item mb-2">
                  <WhiteLabelLink
                    to={`${lng}${WhiteLabelPaths.MediaDesign}`}
                    isActive={location.pathname.includes(
                      WhiteLabelPaths.MediaDesign
                    )}
                    disabled={
                      currentWhiteLabelStep < WhiteLaelStepEnum.MediaDesign
                    }
                  >
                    <MediaIcon className="me-2 fs-4" />{" "}
                    {t("menu.Media & Design")}
                  </WhiteLabelLink>
                </li>
              </ul>
            </small>
          </div>
          <ul className="nav pt-3 pb-4">
            <li className="nav-item">
              <a
                className="nav-link"
                href={ME_TICKET_LINK + locale + "/for-organizers/logout"}
              >
                <BoxArrowLeft className="fs-4 pe-2" />
                <small>{t("menu.logout")}</small>
              </a>
            </li>
            <li className="nav-item">
              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  variant="link"
                  className="nav-link dropdown-toggle text-uppercase"
                >
                  <Globe className="fs-4 pe-2" />
                  <small>{lang}</small>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {languages.map((item) => (
                    <Dropdown.Item
                      key={item.value}
                      onClick={() => changeLanguage(item.value)}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </div>
        <nav className="navbar bg-white fixed-top d-lg-none">
          <div className="container-fluid">
            <button
              onClick={() => setShow(true)}
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <a
              className="navbar-brand"
              href={ME_TICKET_LINK + locale + "/for-organizers/"}
            >
              <img
                src="https://me-ticket.com/assets/img/logo.svg"
                alt="Me ticket"
                width="125"
                height="40"
              />
            </a>
            <Offcanvas
              show={show}
              onHide={() => setShow(false)}
              placement="end"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                  <img
                    src="https://me-ticket.com/assets/img/logo.svg"
                    alt="Me ticket"
                    width="126"
                    height="40"
                  />
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShow(false)}
                ></button>
              </div>
              <div className="offcanvas-body">
                <ul className="nav flex-column pt-3 text-dark">
                  <li className="nav-item">
                    <a
                      className="nav-link text-success text-capitalize"
                      aria-current="page"
                      href={locale + "/create-event"}
                    >
                      <PlusLg className="me-2" /> {t("menu.create")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link "
                      href={
                        ME_TICKET_LINK + locale + "/for-organizers/my-events"
                      }
                    >
                      <ListStars className="me-2" /> {t("menu.events")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link "
                      href={
                        ME_TICKET_LINK +
                        locale +
                        "/for-organizers/ticket-scanner-app"
                      }
                    >
                      <QrCodeScan className="me-2" /> {t("menu.ticket")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={classNames("nav-link", {
                        "opacity-25 disabled": !isProOrganizeer || loading,
                      })}
                      href={
                        ME_TICKET_LINK + locale + "/for-organizers/statistic"
                      }
                    >
                      <Speedometer2 className="me-2" /> {t("menu.statistics")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link "
                      href={ME_TICKET_LINK + locale + "/for-organizers/profile"}
                    >
                      <Person className="me-2" /> {t("menu.profile")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link "
                      href={
                        ME_TICKET_LINK +
                        locale +
                        "/for-organizers/payment-subscription"
                      }
                    >
                      <Calendar4 className="me-2" />{" "}
                      {t("menu.Payment & Subscription")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link "
                      href={
                        ME_TICKET_LINK +
                        locale +
                        "/for-organizers/archive/events"
                      }
                    >
                      <Archive className="me-2" /> {t("menu.archive")}
                    </a>
                  </li>
                  <div className="my-3 d-flex justify-content-between">
                    <div>{t("menu.White Label")}</div>
                    {currentWhiteLabelStep !==
                      WhiteLaelStepEnum.MediaDesign && (
                      <div
                        className={`text-decoration-underline text-success ${whiteLabelLoading ? "text-opacity-50" : "cursor-pointer"}`}
                        onClick={handleHowToStart}
                      >
                        {t("whiteLabel.How to Start?")}
                      </div>
                    )}
                  </div>
                  <li className="nav-item">
                    <WhiteLabelLink
                      to={`${lng}${WhiteLabelPaths.ProjectSettings}`}
                      isActive={location.pathname.includes(
                        WhiteLabelPaths.ProjectSettings
                      )}
                    >
                      <Gear className="me-2" /> {t("menu.Project Settings")}
                    </WhiteLabelLink>
                  </li>
                  <li className="nav-item">
                    <WhiteLabelLink
                      to={`${lng}${WhiteLabelPaths.CustomDomain}`}
                      isActive={location.pathname.includes(
                        WhiteLabelPaths.CustomDomain
                      )}
                      disabled={
                        currentWhiteLabelStep < WhiteLaelStepEnum.CustomDomain
                      }
                    >
                      <Globe2 className="me-2" /> {t("menu.Custom Domain")}
                    </WhiteLabelLink>
                  </li>
                  <li className="nav-item">
                    <WhiteLabelLink
                      to={`${lng}${WhiteLabelPaths.MediaDesign}`}
                      isActive={location.pathname.includes(
                        WhiteLabelPaths.MediaDesign
                      )}
                      disabled={
                        currentWhiteLabelStep < WhiteLaelStepEnum.MediaDesign
                      }
                    >
                      <MediaIcon className="me-2" /> {t("menu.Media & Design")}
                    </WhiteLabelLink>
                  </li>
                </ul>
                <ul className="nav pt-5">
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href={ME_TICKET_LINK + locale + "/for-organizers/logout"}
                    >
                      <BoxArrowLeft className="me-1" />
                      {t("menu.logout")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <Dropdown>
                      <Dropdown.Toggle
                        // variant="success"
                        id="dropdown-basic"
                        variant="link"
                        className="nav-link dropdown-toggle text-uppercase"
                      >
                        <Globe className="fs-4 me-1" />
                        <small>{lang}</small>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {languages.map((item) => (
                          <Dropdown.Item
                            key={item.value}
                            onClick={() => changeLanguage(item.value)}
                          >
                            {item.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                </ul>
              </div>
            </Offcanvas>
          </div>
        </nav>
      </div>
    </>
  );
}
